import React from "react";
import "animate.css";
import convincedImg from "../../../assets/convinced.png"

function Convinced() {
  const Instructions= [
    {
      title:"Track items being made for orders.",
    },
    {
      title:"Manufacture items for customers, plan the delivery and production.",
    },
   
    
  ]
  const OrderInstructions= [
    {
      title:"Track items being made for orders.",
    },
    {
      title:"Manufacture items for customers, plan the delivery and production.",
    },
    
    
  ]
  return (
    <div className="animate__animated animate__zoomIn">
      <div className="container  w-11/12  shadow-5xl  mx-auto  px-8 py-8 my-28">
        <div className="grid grid-cols-2 gap-20 font-Montserrat">
          <div className="md:flex md:flex-col content-start  justify-items-start">
          <h2 className="text-blue-200 text-2xl font-bold">Order Fulfillment</h2>
             {OrderInstructions.map((item, i) => (
             <div key={i} className="list-item pt-2 ml-8">
             
             <div>{item.title}</div>
           </div>
            ))}
            <h2 className="text-blue-200 text-2xl mt-8 font-bold">Convinced ?</h2>
             {Instructions.map((item, i) => (
             <div key={i} className="list-item pt-2 ml-8">
             
             <div>{item.title}</div>
           </div>
            ))}
          </div>
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <div>
              <img
                src={convincedImg}
                alt="Logo"
                className="h-80 rounded-sm  "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Convinced;
